import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Named } from '../base/named';
import { IModel } from '../base/annotation';
import { TriggerProperties } from './trigger-properties';
import { TriggerType } from './trigger-constants';
import { EventTriggerProperties, TriggerEvent } from './event-trigger-properties';

@Metamodel.model({
    name: 'TriggerSettings',
    display: [shellStringResources.Trigger, shellStringResources.Triggers]
})
export class TriggerSettings extends Named {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        type: TriggerProperties.MODEL
    })
    public typeProperties: TriggerProperties;

    @Metamodel.attribute({
        display: shellStringResources.Activated,
        constraint: {
            required: true
        }
    })
    public isActivated: boolean = false;

    public unknownType: boolean = false;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getType(): TriggerType {
        return this.typeProperties ? (Metamodel.modelOf(this.typeProperties).name as TriggerType) : 'Unknown';
    }

    // currently only storage and schedule trigger is supported in trident (schedule is seaparate artifact), but we can keep the following in case we need to support more triggers

    // public createTumblingWindowTrigger(frequency: TriggerFrequency, startTime: Date, interval: number, delay: string,
    //      maxConcurrency: number, endTime?: Date, retryPolicy?: RetryPolicy, dependsOn?: TriggerDependency[]): void {
    //     const tumblingWindowProperties = new TumblingWindowTriggerProperties();
    //     tumblingWindowProperties.setRecurrence(frequency, startTime, interval, delay, maxConcurrency, endTime, retryPolicy);
    //     tumblingWindowProperties.dependsOn = dependsOn || [];
    //     this.properties = tumblingWindowProperties;
    // }

    // public createRerunRangeTumblingWindowTrigger(parentTriggerName: string, startTime: Date, endTime: Date, rerunConcurrency: number): void {
    //    const rerunTumblingWindowProperties = new RerunTumblingWindowTriggerProperties();
    //    rerunTumblingWindowProperties.parentTrigger = parentTriggerName;
    //    rerunTumblingWindowProperties.requestedStartTime = startTime;
    //    rerunTumblingWindowProperties.requestedEndTime = endTime;
    //    rerunTumblingWindowProperties.rerunConcurrency = rerunConcurrency;
    //    this.properties = rerunTumblingWindowProperties;
    // }

    public createBlobEventsTrigger(scope: string, tenantId: string, events: TriggerEvent[], blobPathBeginsWith?: string, blobPathEndsWith?: string,
        ignoreEmptyBlobs?: boolean, maxConcurrency?: number, dmtsConnectionId?: string, storageAccountName?: string): void  {
        const blobEventsTriggerProperties = new EventTriggerProperties();
        blobEventsTriggerProperties.scope = scope;
        blobEventsTriggerProperties.tenantId = tenantId;
        blobEventsTriggerProperties.blobPathBeginsWith = blobPathBeginsWith;
        blobEventsTriggerProperties.blobPathEndsWith = blobPathEndsWith;
        blobEventsTriggerProperties.events = events || [];
        blobEventsTriggerProperties.ignoreEmptyBlobs = ignoreEmptyBlobs;
        blobEventsTriggerProperties.maxConcurrency = maxConcurrency;
        blobEventsTriggerProperties.dmtsConnectionId = dmtsConnectionId;
        blobEventsTriggerProperties.storageAccountName = storageAccountName;
        this.typeProperties = blobEventsTriggerProperties;
    }

    // public createChainingTrigger(dependsOn: Pipeline[], runDimension: string): void { // todo fix any
    //     const chainingTriggerProperties = new ChainingTriggerProperties();
    //     chainingTriggerProperties.dependsOn = dependsOn;
    //     chainingTriggerProperties.runDimension = runDimension;
    //     this.properties = chainingTriggerProperties;
    // }

    // public createCustomEventsTrigger(scope: string, tenantId: string, events: string[], subjectBeginsWith?: string, subjectEndsWith?: string, advancedFilters?: IAdvancedFilter[]): void  {
    //     const eventsTriggerProperties = new CustomEventsTriggerProperties();
    //     eventsTriggerProperties.scope = scope;
    //     eventsTriggerProperties.tenantId = tenantId;
    //     eventsTriggerProperties.subjectBeginsWith = subjectBeginsWith;
    //     eventsTriggerProperties.subjectEndsWith = subjectEndsWith;
    //     eventsTriggerProperties.events = events || [];
    //     eventsTriggerProperties.advancedFilters = advancedFilters || [];
    //     this.properties = eventsTriggerProperties;
    // }
}
